import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { dict } from "./dict";

const get = (o, k) => k.split(".").reduce((a, p) => (a == null ? undefined : a[p]), o);
const LangCtx = createContext(null);
export const LANGS = ["tr", "en", "ru"];

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kvp_lang") || "tr");
  useEffect(() => {
    localStorage.setItem("kvp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback(
    (key, vars) => {
      let s = get(dict[lang], key) ?? get(dict.tr, key) ?? key;
      if (vars && typeof s === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          s = s.replaceAll(`{${k}}`, v);
        });
      }
      return s;
    },
    [lang]
  );
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useT = () => useContext(LangCtx);
export const taskTitle = (task, lang) => task.title?.[lang] || task.title?.tr || "";
